﻿import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { TRequireDocumentStatus } from '~/modules/covenants/types.ts';
import { REQUIRED_DOCUMENT_UPLOAD_MODAL_CONTENT } from '~/modules/covenants/CovenantsDataApplicationForm/constants.ts';

interface IRequiredDocumentUploadConfirmModalProps {
  open: boolean;
  status: Exclude<TRequireDocumentStatus, 'PENDING'> | null;
  onConfirm: () => void;
  onClose: () => void;
}

export const RequiredDocumentUploadConfirmModal: React.FC<
  IRequiredDocumentUploadConfirmModalProps
> = ({ open, status, onConfirm, onClose }) => {
  if (!status) {
    return null;
  }

  const content = REQUIRED_DOCUMENT_UPLOAD_MODAL_CONTENT[status];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{content.title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {content.message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Відмовитись
        </Button>
        <Button variant="contained" onClick={onConfirm}>
          Підтвердити
        </Button>
      </DialogActions>
    </Dialog>
  );
};
